import axios from 'axios';
import {apiBaseUrl} from "../../../helpers/UrlHelper";
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {handleError, handleSuccess} from '../../../helpers/ErrorHelper'

function _success(success) {
    return {type: 'GET_RESEND_EMAIL_SUCCESS', success};
}

function _error(error) {
    return {type: 'GET_RESEND_EMAIL_ERROR', error};
}

function _processing(processing) {
    return {type: 'GET_RESEND_EMAIL_PROCESSING', processing};
}

function getResendEmail(organization_id,invoice_id) {
    return (dispatch) => {
        dispatch(_processing(true));
        dispatch(_success(null));
        dispatch(_error(null));
        const request = axios({

            url: apiBaseUrl(`admin/organizations/${organization_id}/invoices/${invoice_id}/resend-email`),
            method: "get",
            dataType: 'json',
            headers: {'Authorization': 'Bearer ' + loginToken()}
        })
            .then(function (res) {
                dispatch(_success(res));
                dispatch(_processing(false));
                handleSuccess(res)
            }).catch(function (error) {
                dispatch(_error(error));
                dispatch(_processing(false));
                handleError(error)
            });

        return {
            type: 'GET_RESEND_EMAIL_SUCCESS',
            payload: request
        }
    }
}


export default getResendEmail;